// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import styled from 'styled-components';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { ControlLabel } from 'react-bootstrap';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import ActivityFormFieldWrapper from './ActivityFormFieldWrapper';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import RadioButtons from '../../utils/FormWidgets/RadioButtons';

const StyledRadioButtons = styled(RadioButtons)`
  .radio {
    width: 130px;
  }
`;

type ActivityFormRadioFieldProps = {
  label: string;
  name: string;
  options: { label: string; value: boolean }[];
  value: boolean;
  onRadioChange: (value: string) => void;
  disabled?: boolean;
};

const ActivityFormRadioField = ({
  label,
  name,
  options,
  value,
  onRadioChange,
  disabled,
}: ActivityFormRadioFieldProps) => (
  // @ts-ignore
  <ActivityFormFieldWrapper label={label}>
    <ControlLabel>{label}:</ControlLabel>
    <StyledRadioButtons
      options={options}
      name={name}
      value={value}
      onRadioChange={onRadioChange}
      label={label}
      disabled={disabled}
    />
  </ActivityFormFieldWrapper>
);

export default ActivityFormRadioField;
